export default "__VITE_ASSET__BPoW4JSL__"